import { Modal } from "antd";
import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import AddBank from "../../assets/images/AddBank.svg";
import Wallet from "../../assets/images/editBank.svg";
import { setBankModal } from "../../actions/bankActions";
import { useNavigate } from "react-router";
import { injectIntl } from "react-intl";
import { isStripe } from "../../utils/paymentProvider";
import { ROUTES } from "../../constants/routes";

const BankModal = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const BankModal = useSelector((state) => state?.bankInfo?.bankModal);
  const fullUser = useSelector((state) => state?.common?.fullUser);
  const paymentType = useSelector((state) => state?.bankInfo?.paymentType);
  const userData = JSON.parse(localStorage.getItem("data"));
  const navigateTo = () => {
    // Under Stripe every legacy destination below is either redirected away by
    // StripeRouteGuard or gone entirely, so route straight to the real screens:
    // payers manage a card, payees onboard for payouts. The legacy branches keep
    // the AeroPay behaviour for the non-Stripe provider.
    //
    // Split on the dispatched paymentType, NOT on user_type: a contractor is
    // dual-role, and hiring a gigster from chat dispatches "send" — they are the
    // payer there and need a card, not Connect onboarding. A homeowner is always
    // a payer, so they stay the fallback when paymentType was never set.
    if (isStripe()) {
      const isPayer =
        paymentType === "send" || userData?.user_type === "homeowner";
      navigate(isPayer ? ROUTES.STRIPE_ADD_CARD : ROUTES.STRIPE_ONBOARDING);
    } else if (userData?.user_type === "homeowner") {
      navigate("/bank-accounts");
    } else if (userData?.user_type === "contractor") {
      navigate("/payment-options");
    } else if (fullUser?.receivingAccountVerify && fullUser?.kyc) {
      navigate("/bank-info");
    } else if (fullUser?.receivingAccountVerify) {
      // Legacy-only branch. `/w9-form` was never a registered route — only
      // `/view-w9-form` exists — so this navigated into a blank page. `?path=receive`
      // is required: W9from picks the individual vs company card from it, and
      // without it a gigster is shown the empty company/EIN form.
      navigate("/view-w9-form?path=receive");
    } else {
      navigate("/get-payments");
    }
    dispatch(setBankModal(false));
  };

  const handleCancel = useCallback(() => {
    dispatch(setBankModal(false));
  });
  const handleBankImageClick = useCallback(() => {
    navigateTo();
  });
  const handleWalletImageClick = () => {
    dispatch(setBankModal(false));
    navigate("/get-payments?path=debitcard");
  };
  return (
    <Modal
      open={BankModal}
      footer={null}
      destroyOnClose={true}
      onCancel={handleCancel}
    >
      <div className="d-flex flex-column">
        <span className="fs-3 fw-bold mb-3 text-center mt-3">
          {props.intl.formatMessage({ id: "Select" })}
        </span>
        <div className="d-flex justify-content-around align-items-center">
          <div className="d-flex flex-column justify-content-center align-items-center">
            <img
              src={AddBank}
              className="bank-modal-image"
              onClick={handleBankImageClick}
            />
            <span className="bank-modal-text">
              {props.intl.formatMessage({ id: "add_bank_info" })}
            </span>
          </div>
          {/* Legacy-only: the debit-card path targets an AeroPay screen that
              StripeRouteGuard redirects away under Stripe, where payouts go to a
              bank via Connect rather than a debit card. */}
          {!isStripe() && userData?.user_type === "tradesman" && (
            <div className="d-flex flex-column justify-content-center align-items-center">
              <img
                src={Wallet}
                className="bank-modal-image"
                onClick={handleWalletImageClick}
              />
              <span className="bank-modal-text">
                {props.intl.formatMessage({ id: "add_debit_card" })}
              </span>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};
export default injectIntl(BankModal);
